function markMailHub2FromDesk(): void {
  try {
    if (window.parent === window) return;
    if (new URLSearchParams(window.location.search).get("aurelia_hub") === "2") {
      window.__mailHub2 = true;
    }
  } catch {
    /* onglet ou PWA : la connexion actuelle reste */
  }
}

markMailHub2FromDesk();

/** Fenêtre du hub 2. La PWA et le hub 1 ne passent pas ici. */
export function isMailHub2Desk(): boolean {
  return window.__mailHub2 === true;
}

/** Clés hub à préserver lors d’un CLEAR_CACHE (doc hub-vidage-cache-iframes.md). */
export const MAIL_CLEAR_CACHE_PRESERVE_KEYS = [
  "userId",
  "suite_user_id",
  "userName",
  "email",
  "aurelia_purge_seen",
  "mail-account-settings-v1",
  "mail_theme",
  "mail_accent",
  "mail_build_version",
  "mail_web_push_enabled_v1",
  "mail_web_push_sw_build",
  "mail_sw_prompted_build",
];

export function isMailEmbeddedInHub(): boolean {
  try {
    return window.parent !== window;
  } catch {
    return false;
  }
}

export function readStoredSuiteUserId(): string | null {
  if (isMailHub2Desk()) return null;

  if (typeof window.readStoredSuiteUserId === "function") {
    const fromShared = window.readStoredSuiteUserId();
    if (fromShared) return String(fromShared);
  }

  try {
    const local =
      localStorage.getItem("suite_user_id") || localStorage.getItem("userId");
    if (!local || !/^\d+$/u.test(local)) {
      sessionStorage.removeItem("suite_user_id");
      return null;
    }
    return local;
  } catch {
    return null;
  }
}

export function persistSuiteUserId(userId: string | number): void {
  if (isMailHub2Desk()) return;
  if (typeof window.persistSuiteUserId === "function") {
    window.persistSuiteUserId(userId);
    return;
  }
  const v = String(userId);
  if (!/^\d+$/u.test(v)) return;
  try {
    localStorage.setItem("suite_user_id", v);
    localStorage.setItem("userId", v);
    sessionStorage.setItem("suite_user_id", v);
  } catch {
    /* ignore */
  }
}

export function syncSuiteUserIdFromQuery(): string | null {
  if (isMailHub2Desk()) return null;
  if (typeof window.syncSuiteUserIdFromQuery === "function") {
    const id = window.syncSuiteUserIdFromQuery();
    if (id) return String(id);
  }
  try {
    const q = new URLSearchParams(window.location.search);
    const id = q.get("suite_user_id") || q.get("userId");
    if (id && /^\d+$/u.test(id)) {
      persistSuiteUserId(id);
      return id;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clearStoredSuiteUserId(): void {
  try {
    localStorage.removeItem("suite_user_id");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("suite_user_id");
  } catch {
    /* ignore */
  }
}

export function mailAuthHeaders(): Record<string, string> {
  if (isMailHub2Desk()) return { "X-Aurelia-Hub": "2" };
  const id = readStoredSuiteUserId();
  return id ? { "X-User-Id": id } : {};
}

declare global {
  interface Window {
    __mailSessionVerified?: boolean;
    __mailHub2?: boolean;
    readStoredSuiteUserId?: () => number | string | null;
    persistSuiteUserId?: (userId: number | string) => void;
    syncSuiteUserIdFromQuery?: () => number | string | null;
  }
}

export function markMailSessionVerified(): void {
  window.__mailSessionVerified = true;
}

export function clearMailSessionVerified(): void {
  window.__mailSessionVerified = false;
}

/** Session validée serveur uniquement (aligné Photos / Coffre / suite-shared README § C). */
export function isMailSessionVerified(): boolean {
  return window.__mailSessionVerified === true;
}
